import { ObservableNumber } from "./observableTypes";
import DestructorTree from "./DestructorTree";

export default class ReferenceCounter extends ObservableNumber {
	private on_empty_handlers = new Map<() => void, boolean>();
	private on_destroy_handlers = new Set<() => void>();
	private _destroyed = false;
	constructor() {
		super(0);
	}
	get destroyed(): boolean {
		return this._destroyed;
	}
	private deregister(): void {
		if (this.destroyed) return;
		this.decrement();
		if (this.value <= 0) {
			for (const [handler, persist] of this.on_empty_handlers) {
				handler();
				if (!persist) {
					this.on_empty_handlers.delete(handler);
				}
			}
		}
	}
	add_registration(destructor: DestructorTree): void {
		this.increment();
		destructor.onDestroy(() => this.deregister());
	}
	onEmpty(handler: () => void, persist = false, skip_first = false): void {
		this.on_empty_handlers.set(handler, persist);
		if (!skip_first && this.value === 0) {
			handler();
			if (!persist) {
				this.on_empty_handlers.delete(handler);
			}
		}
	}
	get count(): number {
		return this.value;
	}
	onDestroy(handler: () => void): {unsubscribe: () => void} {
		this.on_destroy_handlers.add(handler);
		return {
			unsubscribe: () => this.on_destroy_handlers.delete(handler)
		};
	}
	destroy(): void {
		for (const handler of this.on_destroy_handlers.keys()) {
			handler();
		}
		this._destroyed = true;
	}
}
